<div  (click)="togleEdition()">
    <nb-card>
      <nb-card-header>
        Titulo de registro {{registro.recordData.parcelaName}}
      </nb-card-header>
      <nb-card-body>
        Contenido del registro
      </nb-card-body>
    </nb-card>

</div>
